var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-wrapper"},[_c('div',{staticClass:"twilight purple-shadow above"}),_c('div',{staticClass:"twilight white-shadow above"}),_c('div',{staticClass:"content-container"},[_vm._t("default")],2),_c('div',{staticClass:"twilight white-shadow below"}),_c('div',{staticClass:"twilight purple-shadow below"})])
}
var staticRenderFns = []

export { render, staticRenderFns }